<div class="chart-holder" style="background: #161616;">
    <ng-select [(ngModel)]="selectedYearNum" placeholder="Choose a year" [searchable]="false" [clearable]="false"
        (change)="selectYearNum($event)"
        style="position: absolute; right: 40px; top: 55px; z-index: 1; font-size: 12px; width: 130px">
        <ng-option *ngFor="let yearNum of yearNums" [value]=yearNum.value>{{yearNum.desc}}</ng-option>
    </ng-select>
    <div #myCharts echarts [options]="chartOption" class="demo-chart" (chartInit)="onChartInit($event)"></div>
</div>